module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_8.99fc3c19.jpg";